import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { DOCUMENT } from '@angular/common';

export const authGuard: CanActivateFn = (route, state) => {
  // const auth = inject(AuthService);
  const document = inject(DOCUMENT);
  const router = inject(Router);
  const jwtService = inject(JwtHelperService);
  const localStorage = document.defaultView?.localStorage;
  if (
    !localStorage ||
    localStorage.getItem('TheToken') === null ||
    jwtService.isTokenExpired(localStorage.getItem('TheToken'))
  ) {
    return router.parseUrl('/login');
  }
  return true;
  // if (auth.hasToken() && !jwtService.isTokenExpired(auth.getToken()!)) {
  //   return true;
  // } else {
  //   return router.parseUrl('/login');
  // }
};
